exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-container[data-v-077c3b7a]{border:1px solid;border-color:#ccc!important;border-radius:.5rem;overflow:hidden}[data-v-077c3b7a] .v-input__prepend-outer{margin-right:-1px!important}[data-v-077c3b7a] .padded .v-input__slot{padding-left:8px!important}[data-v-077c3b7a] .v-datatable.v-table>thead{display:table;width:100%;table-layout:fixed}table.v-table>thead tr[data-v-077c3b7a]{background-color:#ddd;height:40px}[data-v-077c3b7a] .v-datatable.v-table>tbody tr{display:table;width:100%;table-layout:fixed}@media (max-width:600px){[data-v-077c3b7a] .v-datatable.v-table>thead{display:block}}", ""]);

// exports
